module.exports = __webpack_public_path__ + "img/inline-desktop-arabic.7b309f77.png";